import {
  HomeOutlined,
  FileTextOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { ButtonTypes } from "./ButtonTypes";

// Constants for header
export const LOGO_SRC = "../assets/OIP.jpg";
export const LOGO_ALT = "SUSTAINABILITY Logo";
export const LOGO_TEXT = "SUSTAINABILITY  PROGRAM";
export const USERNAME_PLACEHOLDER = "";

// Constants for sidenav
export const MENU_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    path: "/supplier/dashboard",
    icon: <HomeOutlined />,
  },
  {
    key: "reporting",
    label: "Reporting",
    path: "/supplier/reporting",
    icon: <FileTextOutlined />,
  },
  {
    key: "goals",
    label: "Goals",
    path: "/supplier/goals",
    icon: <StarOutlined />,
  },
];

// Tabs and buttons configuration


export const REPORTING_NESTED_TABS = [
  { key: "energy", tab: "Energy" },
  { key: "waste", tab: "Waste" },
  { key: "packaging", tab: "Packaging" },
];

export const BUTTON_CONFIGS = [
  { id: 1, text: ButtonTypes.SAVE, className: "save-button" },
  { id: 2, text: ButtonTypes.NEXT, className: "next-button" },
  {id:3, text: 'Reset', className: 'reset-button' },
];

export const LABELS = {
  SUPPLIER_NAME: "Supplier Name",
  REPORT_CREATION_YEAR: "Report Creation Year",
  PERIOD_START_DATE: "Period Start Date",
  PERIOD_END_DATE: "Period End Date",
  CDP_DATA_AVAILABLE: "Is CDP data available?",
  OTHER_DATA_TO_REPORT: "Do you have any other data to report?",
  FOCUS_AREAS: "Focus Areas",
  ENERGY: "Energy",
  WASTE: "Waste",
  PACKAGING: "Packaging",
  OTHER: "Others",
};

export const SUPPLIER_ID = "12";

export const CONFIRMATION_MESSAGES = {
  RESET: {
    title: "Confirm Reset",
    message: "This will clear all your unsaved changes.",
  },
  SAVE: {
    title: "Confirm Save",
    message: "Are you sure you want to save your changes?",
  },
  NEXT: {
    title: "Unsaved Changes",
    message:
      "You have unsaved changes. Do you want to save them before proceeding to the next section?",
  },
  TABCHANGE:'Do you want to save changes before tab change?'
};

// Notification Messages
export const NOTIFICATION_MESSAGES = {
  SAVE_SUCCESS: {
    message: "Save Successful",
    description: "Your data has been saved successfully.",
  },
  SAVE_FAILED: {
    message: "Save Failed",
    description: "There was an error saving your data. Please try again.",
  },
  END_OF_TABS: {
    message: "End of Tabs",
    description: "You are already on the last tab.",
  },
  resetSuccessful: {
    message: "Reset Successful",
    description: "Data has been reset successfully.",
  },
  resetFailed: {
    message: "Reset Failed",
    description: (error) => `Error resetting data: ${error.message}`,
  }
};

// Default Tab Keys
export const DEFAULT_TAB_KEYS = {
  MAIN: "preSurvey",
  NESTED: "energy",
};

export const DATE_FORMAT = "DD-MM-YYYY";

export const DATE_MESSAGES = {
  EMPTY_START_DATE:
    "Start date is required  in the format DD-MM-YYYY.",
  EMPTY_END_DATE:
    "End date is required in the format DD-MM-YYYY.",
  INVALID_DATE_FORMAT: "Please enter a valid date format.",
  END_DATE_BEFORE_START_DATE: "End date cannot be before the start date.",
  END_DATE_SAME_AS_START_DATE: "End date cannot be the same as the start date.",
  END_DATE_MIN_ONE_YEAR_GAP:
    "End date must be at least one year after the start date.",
  START_DATE_FUTURE_YEAR: "Start date cannot be in the future.",
};

// ConfirmationDialogConstants
export const MODAL_CONSTANTS = {
  TITLE: "Confirm Action",
  DEFAULT_MESSAGE: "Are you sure you want to proceed?",
  YES_BUTTON_TEXT: "Yes",
  NO_BUTTON_TEXT: "No",
};
export const MESSAGES = {
  VALIDATION: {
    REQUIRED_FOCUS_AREA: "Please select at least one focus area.",
    INVALID_START_DATE: "Start date cannot be in the future.",
    INVALID_END_DATE: "End date cannot be earlier than the start date.",
    DESCRIPTION:"Please fill in all required fields correctly",
    VALIDATION:"Validation Error",
  },
};

export const VALIDATIONS={
  OTHERS_DATA:"Make a selection",
  SUPPLIER_NAME:"Supplier name is required"

}
export const DASH_BOARD_TEXT = "supplier dashboard screen";

export const isEmpty = (obj)=> {
  return Object.keys(obj).length === 0;
}
